var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c('div',{staticClass:"contentCenter all"},[_c('section',{staticClass:"importcontacts"},[_c('MyContacts')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }